import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const KAKAO_REST_API_KEY = '7b084dce651d696a9b15e34dc7d6f5b5';
const KAKAO_REDIRECT_URI = window.location.hostname === 'localhost'
  ? 'http://localhost:3000/auth/kakao/findpw-callback'
  : 'https://campuslife-assistant.com/auth/kakao/findpw-callback';

function FindPwPage() {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL || 'https://campus-life-production.up.railway.app';

  const [kakaoVerified, setKakaoVerified] = useState(false);
  const [kakaoId, setKakaoId] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const verified = sessionStorage.getItem('findpwKakaoVerified');
    const id = sessionStorage.getItem('findpwKakaoId');
    if (verified === 'true') {
      setKakaoVerified(true);
      setKakaoId(id || '');
      sessionStorage.removeItem('findpwKakaoVerified');
      sessionStorage.removeItem('findpwKakaoId');
    }
  }, []);

  const showAlert = (msg, success = false) => {
    setAlertMessage(msg);
    setIsSuccess(success);
    setShowAlertModal(true);
  };

  const handleKakaoAuth = () => {
    const kakaoAuthUrl = `https://kauth.kakao.com/oauth/authorize?client_id=${KAKAO_REST_API_KEY}&redirect_uri=${KAKAO_REDIRECT_URI}&response_type=code&prompt=login`;
    window.location.href = kakaoAuthUrl;
  };

  const handleResetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      showAlert('새 비밀번호를 입력해주세요.');
      return;
    }
    if (newPassword.length < 8) {
      showAlert('비밀번호는 최소 8글자 이상이어야 합니다.');
      return;
    }
    if (!/[a-zA-Z]/.test(newPassword)) {
      showAlert('비밀번호에 영문자를 최소 1개 포함해주세요.');
      return;
    }
    if (!/[0-9]/.test(newPassword)) {
      showAlert('비밀번호에 숫자를 최소 1개 포함해주세요.');
      return;
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(newPassword)) {
      showAlert('비밀번호에 특수문자를 최소 1개 포함해주세요.');
      return;
    }
    if (newPassword !== confirmPassword) {
      showAlert('비밀번호가 일치하지 않습니다.');
      return;
    }

    try {
      const res = await fetch(`${apiUrl}/api/auth/reset-password-kakao`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kakaoId, newPassword })
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        showAlert('비밀번호가 성공적으로 변경되었습니다!', true);
      } else {
        showAlert(data.message || '비밀번호 변경에 실패했습니다.');
      }
    } catch {
      showAlert('서버 연결 실패! 잠시 후 다시 시도해주세요.');
    }
  };

  return (
    <div style={containerStyle}>
      <button onClick={() => navigate('/')} style={backBtn}>← 이전으로</button>
      <div style={formWrapper}>
        <h2 style={titleStyle}>비밀번호 찾기</h2>

        {!kakaoVerified ? (
          <>
            <p style={descStyle}>카카오 본인인증 후 비밀번호를 변경할 수 있어요.</p>
            <button style={kakaoBtn} onClick={handleKakaoAuth}>
              <img src="https://developers.kakao.com/assets/img/about/logos/kakaolink/kakaolink_btn_medium.png"
                alt="kakao" style={{ width: '20px', marginRight: '8px', verticalAlign: 'middle' }} />
              카카오로 본인인증
            </button>
          </>
        ) : (
          <>
            <div style={verifiedBadge}>✅ 카카오 인증 완료</div>
            <p style={descStyle}>새로운 비밀번호를 입력해주세요.</p>
            <div style={inputGroup}>
              <input type="password" placeholder="새 비밀번호 (8자 이상, 영문/숫자/특수문자 포함)"
                style={inputStyle} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
              <input type="password" placeholder="새 비밀번호 확인"
                style={inputStyle} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
            </div>
            <button style={mainBtn} onClick={handleResetPassword}>비밀번호 변경</button>
          </>
        )}

        <div style={linkGroup}>
          <span onClick={() => navigate('/')} style={linkStyle}>로그인으로 돌아가기</span>
        </div>
      </div>

      {showAlertModal && (
        <div style={customModalOverlayStyle}>
          <div style={customModalContentStyle}>
            <h3 style={customModalTitleStyle}>{alertMessage}</h3>
            <button style={{ ...customModalConfirmButtonStyle, backgroundColor: '#000', padding: '10px 40px' }}
              onClick={() => { setShowAlertModal(false); if (isSuccess) navigate('/'); }}>
              확인
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const containerStyle = { maxWidth: '450px', margin: '0 auto', padding: '100px 20px', position: 'relative', fontFamily: 'Pretendard, sans-serif' };
const backBtn = { position: 'absolute', top: '40px', left: '20px', padding: '8px 16px', background: '#fff', border: '1px solid #E5E7EB', borderRadius: '16px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)', cursor: 'pointer', fontWeight: '600' };
const formWrapper = { textAlign: 'center' };
const titleStyle = { fontSize: '28px', fontWeight: '800', marginBottom: '10px' };
const descStyle = { color: '#666', marginBottom: '30px', fontSize: '15px' };
const kakaoBtn = { width: '100%', padding: '16px', background: '#FEE500', border: 'none', borderRadius: '14px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', marginBottom: '20px' };
const verifiedBadge = { background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '14px', padding: '14px', color: '#16a34a', fontWeight: '600', marginBottom: '20px' };
const inputGroup = { display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' };
const inputStyle = { padding: '16px', borderRadius: '14px', border: '1px solid #E5E7EB', fontSize: '16px', outline: 'none', background: '#F9FAFB', width: '100%', boxSizing: 'border-box' };
const mainBtn = { width: '100%', padding: '18px', background: '#000', color: '#fff', border: 'none', borderRadius: '14px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' };
const linkGroup = { marginTop: '20px' };
const linkStyle = { color: '#999', fontSize: '14px', cursor: 'pointer', textDecoration: 'underline' };
const customModalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.4)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 };
const customModalContentStyle = { backgroundColor: '#fff', padding: '30px 40px', borderRadius: '16px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', textAlign: 'center', minWidth: '320px' };
const customModalTitleStyle = { fontSize: '18px', fontWeight: '600', color: '#333', margin: '0 0 25px 0', lineHeight: '1.5' };
const customModalConfirmButtonStyle = { border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600', color: '#fff' };

export default FindPwPage;